// src/components/calculatorButton.js
import React from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { evaluate } from 'mathjs'; // Import mathjs for expression evaluation

const SollCalculator = ({ value, onCalculate }) => {
  // Handler for evaluating the expression
  const handleEvaluate = () => {
    try {
      // Evaluate the expression using mathjs
      const result = evaluate(value);
      
      if (typeof result === 'number') {
        onCalculate(result);
      } else {
        alert('Bitte geben Sie einen gültigen Ausdruck ein.');
      }
    } catch (error) {
      alert('Ungültiger Ausdruck. Bitte überprüfen Sie Ihre Eingabe.');
      console.error('Fehler bei der Auswertung des Soll-Ausdrucks:', error);
    }
  };

  return (
    <TextField
      label="Netto"
      value={value}
      onChange={(e) => onCalculate(e.target.value, false)} // Update value without calculating
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleEvaluate}
              edge="end"
              aria-label="Berechne Soll"
            >
              <AddIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SollCalculator;
